export default "__VITE_ASSET__269ff0e2__"